import { getCommonCode } from '../../../../../communication_system/axios_apis/axios_apis';
import createGetRequestThunk from '../../redux_functions/create_get_request_thunk';

import { GET_COMMON_CODE } from './common_code_detail_type';

export const getCommonCodeAsync = createGetRequestThunk(GET_COMMON_CODE, getCommonCode);
